import { Copy } from 'lucide-react';
import { useState } from 'react';
import { copyText } from '../lib/clipboard';
import { useI18nStore } from '../i18n/i18nStore';

export function DetailRow({ label, value, copyable }: { label: string; value: string; copyable?: boolean }) {
  const t = useI18nStore((state) => state.t);
  const [copyMessage, setCopyMessage] = useState('');
  const [copyError, setCopyError] = useState(false);

  async function handleCopy() {
    const ok = await copyText(value);
    setCopyError(!ok);
    setCopyMessage(t(ok ? 'copySucceeded' : 'copyFailed'));
    window.setTimeout(() => setCopyMessage(''), 1600);
  }

  return (
    <div className="order-detail-row">
      <span>{label}</span>
      <strong>{value}</strong>
      {copyable && value && value !== '-' ? (
        <button className="icon-button" type="button" onClick={handleCopy} aria-label={t('copy')}>
          <Copy size={14} aria-hidden="true" />
        </button>
      ) : null}
      {copyMessage ? (
        <p className={copyError ? 'form-error order-copy-feedback' : 'form-success order-copy-feedback'} data-order-copy-feedback-react="true">
          {copyMessage}
        </p>
      ) : null}
    </div>
  );
}
